/**
 * Shared deity image resolution for global chanting + Townhall.
 * Prefer API/R2 URLs from the Worker when present; static SVGs remain the offline fallback.
 */

export const CHANT_DEITY_IMAGES = {
  hanuman: "/images/sacred-library/deities/hanuman.svg",
  lalita_tripurasundari: "/images/sacred-library/deities/parvati.svg",
  vishnu: "/images/sacred-library/deities/vishnu.svg",
};

/** Production R2 keys served via Worker `/api/assets/…` after `upload-r2-assets.mjs`. */
export const CHANT_DEITY_R2_PATHS = {
  hanuman: "/api/assets/deities/hanuman.svg",
  lalita_tripurasundari: "/api/assets/deities/parvati.svg",
  vishnu: "/api/assets/deities/vishnu.svg",
};

export const CHANT_ID_DEITY_IMAGES = {
  hanuman_chalisa: CHANT_DEITY_IMAGES.hanuman,
  lalita_sahasranama: CHANT_DEITY_IMAGES.lalita_tripurasundari,
  vishnu_sahasranama: CHANT_DEITY_IMAGES.vishnu,
};

/** True when path looks like a real media URL (not a bare murthy slug). */
export function isUsableChantImageSrc(src) {
  if (!src || typeof src !== "string") return false;
  const s = src.trim();
  if (!s) return false;
  if (s.startsWith("http") || s.startsWith("data:") || s.startsWith("blob:")) return true;
  if (
    s.startsWith("/images/") ||
    s.startsWith("/sacred-library/") ||
    s.startsWith("/api/") ||
    s.startsWith("/townhall/asset/")
  ) {
    return true;
  }
  // Bare slugs like "hanuman_murthy_01" pointed at missing GIFs — do not use.
  if (!s.includes("/") && !s.includes(".")) return false;
  if (s.endsWith(".gif") && s.includes("murthy")) return false;
  return s.startsWith("/");
}

export function resolveChantDeityImage({ chantId, deity, gifRef, overrideSrc, preferR2 } = {}) {
  if (isUsableChantImageSrc(overrideSrc)) return overrideSrc.trim();
  if (preferR2) {
    if (deity && CHANT_DEITY_R2_PATHS[deity]) return CHANT_DEITY_R2_PATHS[deity];
    if (chantId === "hanuman_chalisa") return CHANT_DEITY_R2_PATHS.hanuman;
    if (chantId === "lalita_sahasranama") return CHANT_DEITY_R2_PATHS.lalita_tripurasundari;
    if (chantId === "vishnu_sahasranama") return CHANT_DEITY_R2_PATHS.vishnu;
  }
  if (chantId && CHANT_ID_DEITY_IMAGES[chantId]) return CHANT_ID_DEITY_IMAGES[chantId];
  if (deity && CHANT_DEITY_IMAGES[deity]) return CHANT_DEITY_IMAGES[deity];
  if (isUsableChantImageSrc(gifRef)) {
    if (gifRef.startsWith("/") || gifRef.startsWith("http")) return gifRef;
    return `/images/chanting/${gifRef}.gif`;
  }
  if (gifRef?.includes("hanuman")) return CHANT_DEITY_IMAGES.hanuman;
  if (gifRef?.includes("vishnu")) return CHANT_DEITY_IMAGES.vishnu;
  if (gifRef?.includes("lalita")) return CHANT_DEITY_IMAGES.lalita_tripurasundari;
  return null;
}
